var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[(_vm.errorMessage !== null)?_c('div',{attrs:{"id":"error-message"}},[_c('span',[_vm._v("Error loading data: "+_vm._s(_vm.errorMessage))])]):_vm._e(),_c('rules',{attrs:{"rules":_vm.rulesData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }